import { styled } from "@pigment-css/react";

export const SidePanelContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[24],
  backgroundColor: theme.managementView.colors.neutral[0],
  paddingBottom: theme.managementView.spacing[24],
}));
